import React from 'react'
import ShowReportESPM from './ShowReportESPM'
import ShowReportPSPM from './ShowReportPSPM'

export default function ReportContainer() {
    return (
        <div className='container'>
            <div className="row">
                <p className='text-center'>Aqui podrás ver los reportes así como descargar o imprimir los mismos</p>
            </div>
            <ul className="nav nav-pills" id="pills-tab" role="tablist">
                <li className="nav-item navHeadReport" role="presentation">
                    <button className="nav-link form-control active" id="pills-ESPM-tab" data-bs-toggle="pill" data-bs-target="#pills-ESPM" type="button" role="tab" aria-controls="pills-ESPM" aria-selected="true">Denuncias a <strong>elementos de seguridad pública municipal</strong></button>
                </li>
                <li className="nav-item navHeadReport" role="presentation">
                    <button className="nav-link form-control" id="pills-PSPM-tab" data-bs-toggle="pill" data-bs-target="#pills-PSPM" type="button" role="tab" aria-controls="pills-PSPM" aria-selected="false">Denuncias a <strong>personas servidoras públicas municipales</strong></button>
                </li>
            </ul>
            <div className="tab-content">
                <div className="tab-pane fade show active" id="pills-ESPM" role="tabpanel" aria-labelledby="pills-ESPM-tab">
                    <ShowReportESPM />
                </div>
                <div className="tab-pane fade" id="pills-PSPM" role="tabpanel" aria-labelledby="pills-PSPM-tab">
                    <ShowReportPSPM />
                </div>
            </div>
        </div>
    )
}
